/*
 * a Collection of regions, each showing the survey labels for a single language
 */

define([
  "marionette",
  "./template/surveyLabelListTemplate.html",
  "./template/surveyLabelTemplate.html",
], function (Marionette, SurveyLabelListTemplate, SurveyLabelTemplate) {
  var SurveyLabelDisplayView = {};

  SurveyLabelDisplayView.label = Marionette.ItemView.extend({
    template: SurveyLabelTemplate,
    textboxes: {
      ".survey-label": {
        enableSelector: ".survey-label",
        modelAttribute: "label",
        placeholder: "admin.survey.label",
        textArea: false,
      },
    },
  });

  SurveyLabelDisplayView.languageLabels = Marionette.CompositeView.extend({
    initialize: function () {
      //this view is passed a model (SurveyLabels), but we need a collection of SurveyLabel models.
      //So populate the collection with the survey labels taken from the model.
      this.collection = this.model.getSurveyLabels();
    },
    template: SurveyLabelListTemplate,
    itemView: SurveyLabelDisplayView.label,
    itemViewContainer: "#surveyLabels",
  });

  SurveyLabelDisplayView.surveyLabels = Marionette.CollectionView.extend({
    itemView: SurveyLabelDisplayView.languageLabels,
  });

  return SurveyLabelDisplayView;
});
